import { css } from '../index'

export default css`
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  transform: translateZ(0);
  border: 0;
  background: 0 0;
`
